import { MAIN_PATH } from 'rollouts/navigation';

const indexComponent = require('./routes/list/components/RolloutsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/RolloutsManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/index.js